import { v4 as uuid } from 'uuid';

export const getContactWishlistData = ({
  contactCompany,
  contactFirstName,
  contactLastName,
  contactTitle,
  contactEmail,
  contactPhone,
  parsedDataFullName,
  parsedDataCompany,
  parsedLinkedinUrl,
  url,
  platform,
}) => ({
  contacts: [{
    details: {
      firstName: contactFirstName,
      lastName: contactLastName,
      jobTitle: contactTitle,
      emails: contactEmail ? [
        {
          value: contactEmail,
          type: 'work',
        },
      ] : [],
      company: {
        ...contactCompany,
      },
      phones: contactPhone ? [{
        value: contactPhone,
        type: 'work',
      }] : [],
    },
    identifiers: {
      linkedinUrl: parsedLinkedinUrl,
      fullName: parsedDataFullName,
      companyName: parsedDataCompany,
    },
  }],
  requestMetadata: {
    url,
    platform,
    requestId: uuid(),
    searchVersion: '3.0',
  },
});
